import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function filtersRoutes($stateProvider: StateProvider) {
    let filtersModule: { default: any; };
    $stateProvider
        .state({
            name: 'filters',
            url: '/filters',
            component:  KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => filtersModule.default,
            },
            lazyLoad: async () => {
                filtersModule = await import(/* webpackChunkName: "filters" */ './KpFilters.svelte');
                return null;
            }
        });
}